<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i
            class="fa fa-angle-right"></i></span>
        Internal Courses
      </h6>
      <div class="container-fluid">
        <div class="navbar background_color filter-bar">
          <div class="d-flex flex-wrap align-items-center toolbar-left">
            <b-input-group size="sm" class="search-box"><b-form-input v-model="filter" type="search"
                placeholder="Search" class="bdr-rad"></b-form-input></b-input-group>
            <span class="custom-breadcrumb"><b>Showing {{ filteredCourses.length }} items.</b></span>
          </div>
          <router-link to="/tinternalcourses/create" class="btn btn-outline-primary btn-sm bdr-rad">Create Internal Course</router-link>
        </div>
        <div class="card bdr-rad2 shadow p-2">
          <div class="card-body mb-5">
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div class="d-flex justify-content-center" v-if="isLoading"><div class="spinner-border text-primary"></div></div>
            <div v-else class="table-responsive">
              <b-table small hover show-empty class="course-table" :items="filteredCourses" :fields="fields" head-variant="dark">
                <template #cell(number)="row">{{ row.index + 1 }}</template>
                <template #cell(group_name)="row">{{ groupName(row.item.course_group) }}</template>
                <template #cell(status_name)="row">{{ statusName(row.item.status) }}</template>
                <template #cell(actions)="row">
                  <button type="button" class="btn btn-sm btn-outline-primary bdr-rad" @click="viewCourse(row.item.id)">View</button>
                </template>
                <template #empty><div class="text-center">No internal courses found.</div></template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      filter: '',
      items: [],
      isLoading: true,
      errorMessage: '',
      fields: [
        { key: 'number', label: '#', sortable: true },
        { key: 'course_code', label: 'Course Code', sortable: true },
        { key: 'training_category', label: 'Category', sortable: true },
        { key: 'course_title', label: 'Course Title', sortable: true },
        { key: 'group_name', label: 'Group', sortable: true },
        { key: 'duration', label: 'Duration', sortable: true },
        { key: 'frequency', label: 'Frequency', sortable: true },
        { key: 'remarks', label: 'Remarks', sortable: true },
        { key: 'created_date', label: 'Created Date', sortable: true },
        { key: 'created_by', label: 'Created By', sortable: true },
        { key: 'status_name', label: 'Status', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  computed: {
    filteredCourses() {
      const term = this.filter.trim().toLowerCase();
      if (!term) return this.items;
      return this.items.filter((item) => Object.values(item).some((value) => String(value || '').toLowerCase().includes(term)));
    },
  },
  mounted() { this.loadCourses(); },
  methods: {
    async loadCourses() {
      try {
        const { data } = await axios.get('/ticourses/index', { headers: { Authorization: 'Bearer ' + this.token } });
        this.items = data.data || [];
      } catch (error) {
        this.errorMessage = 'Unable to load internal courses.';
      } finally { this.isLoading = false; }
    },
    groupName(value) { return { 1: 'Refresher', 2: 'Renewal', 3: 'New' }[value] || value || '-'; },
    statusName(value) { return Number(value) === 1 ? 'Active' : 'Inactive'; },
    viewCourse(id) { this.$router.push('/tinternalcourses/view?id=' + id); },
  },
};
</script>

<style scoped>
.course-table { font-size: small; }
.filter-bar { min-height: 52px; }
.toolbar-left { gap: 8px; }
.search-box { width: 220px; }
</style>
